import { createContext, type MutableRefObject } from 'react'
import type { NavItem } from '../lib/navigation'

/**
 * Spec 161, second retour de Christophe sur `dev` (2026-10-12) — la barre d'onglets d'une entrée qui réunit des pages
 * se place SOUS le titre de la page, comme sur « Échéances et budget ». La coquille sait quelle entrée couvre la page ;
 * la page sait où finit son en-tête. Ce contexte relie les deux : la page pose `OngletsDeLEntree` sous son en-tête et le
 * signale, la coquille ne pose alors plus la barre en tête de page — et la pose encore si une page l'oublie (repli : un
 * onglet ne disparaît jamais).
 */
export interface OngletsDeLaPage {
  /** Entrée de menu à onglets qui couvre la page affichée ; `null` hors d'une telle entrée. */
  entree: NavItem | null
  /** Identifiant du panneau que la coquille pose autour de la page (`aria-controls` des onglets). */
  idPanneau: string
  /** +1 quand une page monte sa barre d'onglets, −1 quand elle la démonte. */
  signaler: (delta: 1 | -1) => void
  /**
   * Vrai quand une barre s'est démontée en ayant le focus (squelette remplacé par la page chargée, page quittée par les
   * flèches) : la barre suivante le reprend sur l'onglet ouvert. Sans cela, le focus tombait sur la page (revue à froid).
   */
  focusAReprendre: MutableRefObject<boolean>
}

export const OngletsDeLaPageContext = createContext<OngletsDeLaPage>({
  entree: null, idPanneau: '', signaler: () => {}, focusAReprendre: { current: false },
})
